import { useNavigate } from 'react-router';
import { ErrorScreen } from './ErrorScreen';

interface NotFoundProps {
  title?: string;
  description?: string;
  homeTo?: string; // where the action button navigates
  homeLabel?: string; // label for action button
}

export function NotFound({
  title = 'Page not found',
  description = "The page you're looking for doesn't exist or may have moved.",
  homeTo = '/',
  homeLabel,
}: NotFoundProps) {
  const navigate = useNavigate();

  return (
    <ErrorScreen
      code="404"
      title={title}
      description={description}
      homeLabel={homeLabel}
      onHome={() => navigate(homeTo)}
    />
  );
}
